/**
 * Mirrors the BE `computedData.driverApproved` tri-state (RYDE-8099).
 * The key is absent when no driver approval warning was ever raised for the ride.
 */
export enum RideDriverApprovalEnum {
  approved = "approved",
  notApproved = "notApproved",
}
